import { Roles } from '@monorepo/interfaces';

/**
 * Maps workflow field names to their corresponding Roles enum values
 * Used for GCK-based user filtering in role fields
 */
export const ROLE_FIELD_TO_ENUM_MAPPING: Record<string, Roles> = {
    PLM: Roles.ProductLifecycleManager,
    LOG: Roles.Logistics,
    CS: Roles.CustomerSupport,
    KM: Roles.KnowledgeManager,
    ECC: Roles.ExportClassification,
    CUSTOMS: Roles.Customs,
    COMMERCIAL: Roles.Commercials,
    'E-COMMERCE': Roles.ECommerce,
    FDM: Roles.FactoryDataManager
};

/**
 * Converts a workflow field name to its corresponding Roles enum value
 * Returns undefined if no mapping exists
 */
export function mapFieldNameToRole(fieldName: string): Roles | undefined {
    return ROLE_FIELD_TO_ENUM_MAPPING[fieldName];
}
